export const loadingSpinner = `
  border-solid 
  border-ll-on-surface-variant1
  border-b-[transparent]
  rounded-[50%]
  inline-block
  border-box
  animate-spin

  data-[color=white]:border-white
  data-[color=white]:border-b-[transparent]

  data-[size=small]:h-4
  data-[size=small]:w-4
  data-[size=small]:border-2

  data-[size=medium]:h-6
  data-[size=medium]:w-6
  data-[size=medium]:border-4

  data-[size=large]:h-8
  data-[size=large]:w-8
  data-[size=large]:border-[6px]
`;

export const imageSpinner = `h-[90px] w-[90px] max-h-auto`;
